export default [{
  path: '/pg-mei',
  component: {
    name: 'pgMeiBase',
    template: '<router-view />',
    meta: {
      resource: 'pg_mei',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    query: {
      busca: '',
      filtroRapido: '',
    },
    name: 'pg_mei-view',
    component: () => import('@/app/pg-mei/PgMeiView.vue'),
    meta: {
      resource: 'pg_mei',
      action: 'read',
      navActiveLink: 'pg_mei-view',
      pageTitle: 'PG MEI',
      breadcrumb: [
        {
          text: 'PG MEI',
          to: { name: 'pg_mei-view' },
          active: true,
        },
      ],
    },
  }],
},
]
